import { Cache } from "memory-cache";
import { Client } from "../service/esiclient";
import { CharacterLPEntity } from ".";
import { HandleEsiError } from "../helpers/ErrorDisplayHelper";

// ESI client
const esiClient = new Client();

// Cache
const cache = new Cache();

export async function getCachedCharacterLPEntity(
  character_id: number,
  token: string
): Promise<CharacterLPEntity | null> {
  let entity: any = await cache.get(character_id);
  if (entity) {
    return entity;
  }
  try {
    const lp = await esiClient.get_characters_character_id_loyalty_points(character_id, null, null, token);
    if (lp !== null) {
      entity = new CharacterLPEntity(character_id, lp);
      cache.put(character_id, entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      return null;
    }
  } catch (error) {
    HandleEsiError(error, character_id, "character_lp");
    return null;
  }
}
